import React, {useContext} from "react";
import {Dropdown} from "react-bootstrap";
import {LanguageContext, getLanguageStr, getLangFile} from "../../contexts/language/LanguageContext";
import {convertLangFile} from "../../i18n/defineMessages";
import {ModalContext} from "../../contexts/modal/ModalContext";
import {AuthContext} from "../../contexts/auth/AuthContext";
import {useIntl} from "react-intl";
import messages from "../../i18n/messages";
import {useNavigate} from "react-router-dom";


const LangSelection = () => {
    const [langContext, setLangContext] = useContext(LanguageContext);
    const [, setModalContext] = useContext(ModalContext);
    const [authContext, ] = useContext(AuthContext);
    const intl = useIntl();
    const navigate = useNavigate();
    const onLangChange = (lang) => {
        if (authContext.isAuthenticated) {
            setModalContext({
                isShow: true,
                title: intl.formatMessage(messages.changeLanguageModalTitle),
                content: intl.formatMessage(messages.changeLanguageModalContent),
                onConfirm: () => {
                    doChange(lang);
                },
            });
        } else {
            doChange(lang);
        }
    }

    const doChange = (lang) => {
        const langFile = getLangFile(lang);
        const langMsg = convertLangFile(langFile, 'maxi-ding');
        setLangContext({...langContext, locale: lang, langMsg: langMsg});
        window.sessionStorage.setItem("maxiLocale", lang);
        navigate("/");
        window.location.reload();
    }

    return (
        <Dropdown>
            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                {getLanguageStr(langContext.locale)}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item onClick={() => onLangChange('en')} >EN</Dropdown.Item>
                <Dropdown.Item onClick={() => onLangChange('de')}>DE</Dropdown.Item>
                <Dropdown.Item onClick={() => onLangChange('zh')}>中文</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default LangSelection;